var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNvgtrBm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 558,
    height: 268,
    viewBox: "0 0 558 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.902 0.172614C198.292 4.33261 163.672 92.9626 139.282 135.543C121.792 166.073 89.2124 227.253 47.7624 224.773C35.8124 224.063 29.0124 215.113 15.7024 216.953C7.90242 218.033 0.60242 226.653 0.0524198 234.323C-1.38758 254.593 27.1824 265.423 43.6324 266.843C140.032 275.203 184.832 128.833 228.302 66.5426C244.452 43.4026 269.312 33.7126 275.842 69.6326C285.462 122.473 268.722 229.903 331.132 256.343C375.262 275.033 412.082 232.943 434.932 201.183C442.412 190.793 466.812 157.993 469.832 148.083C474.522 132.703 464.622 118.833 448.052 122.303C439.522 124.093 432.862 132.583 427.712 138.963C408.662 162.553 351.522 268.483 329.592 186.873C319.462 149.163 323.562 106.983 318.982 68.4826C314.812 33.5626 293.822 -2.81739 253.902 0.172614Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 514.5,
    cy: 43.5,
    r: 43.5,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNvgtrBm);
export default __webpack_public_path__ + "static/media/nvgtr_BM.087cde3e50f4d5420ba96cc9adf6f62b.svg";
export { ForwardRef as ReactComponent };